import React, { Suspense } from 'react'
import styled from 'styled-components'

import Gas from '@assets/icons/gas.inline.svg';
import Energy from '@assets/icons/electricity.inline.svg';
import Retailer from '@assets/icons/retailer.inline.svg';

const icons = {
    gas: Gas,
    energy: Energy,
    retailer: Retailer
}

const Award = props => {
    
    const IconComponent = props.relationships.icon ? icons[props.relationships.icon.name] : null;
    return (
        <Style> 
            { IconComponent ? <div className="icon theme--primary"><IconComponent /></div> : null}
            <h4>{ props.award}</h4>
            <small>{ props.awardedBy }</small>
            <time>{ props.awardYear }</time>
        </Style>
    )
}
export default Award

const Style = styled.div.attrs(props => ({
    className: 'award'
}))`
    display: flex;
    flex-direction: column;
    text-align: center;

    * + &  {
        margin-top: 2em;
    }

    .icon {
        text-align: center;
        margin-bottom: .25em;
        margin-inline: auto;

        svg {
            width: auto;
            max-height: 3.25em;
        }
    }

    > h4 {
        order: 3;
        font-size: 1.15em;
        text-transform: uppercase;
        margin-bottom: 0;
        color: var(--text-color);
    }

    > small {
        color: ${props => props.theme.colors.grey};
        order: 2;
    }

    > time {
        order: 4;
        font-weight: 600;
        font-size: .85em;
        display: flex;
        justify-content: center;
        align-items: center;
        color: black;

        &::before,
        &::after {
            content:'';
            width: 1.25em;
            height: 1px;
            margin: 0 .5em;
            background-color: ${props => props.theme.colors.black};
            display: inline-block;

            @media (prefers-color-scheme: dark) {
                background-color: ${props => props.theme.colors.white};
            }
        }
    }
`